import type { FaireProductEntity } from "../../entity_types/product";

export const p_cag49qlfzl: FaireProductEntity = {
  token: "p_cag49qlfzl",
  type: "product",
  name: "Soft Woolie Sabrina Ribbed Beanie – Unisex & Chic",
  brandToken: "b_32rsz10vd0",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1d9c36d0e1d4928326eed98ab1de8d73ff890a0caa3459da2179c0aed30cedcf.png",
  galleryImageUrls: [],
  priceDollars: 18.5,
  description:
    "🧢 Stay warm and effortlessly stylish with the Soft Woolie Ribbed Beanie! Designed for all-day comfort, this unisex knit hat features strategic ribbing for a chic, modern touch. Whether you're heading out for a casual day, city stroll, or winter adventure, this cozy and breathable beanie keeps you snug without overheating. A must-have cold-weather accessory that pairs perfectly with any outfit—from street style to classic layering.\n\nWhy You’ll Love It:\n🧶 Ultra-Soft & Cozy – Made for warmth and comfort without bulk\n🖤 Unisex & Versatile – Stylish for everyone in a modern, ribbed design\n🌡️ Perfect for Cold Weather – Keeps you warm yet breathable\n🎁 Great Gift Idea – Ideal for fashion lovers & practical winter wear\n✨ Effortless Style – Pairs seamlessly with casual & dressed-up outfits\n\n📏 Material: Soft wool blend for warmth & durability\n\n🧣✨ Wrap up in style—shop the Soft Woolie Ribbed Beanie now! ✨🧢",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:20.591Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
